export default "__VITE_ASSET__a9A9r0$V__"